import ApplicationFieldset from "../fieldset";
import ApplicationBiographyAndJoining from "./aboutYou/biographyAndJoining";
import ApplicationAboutYouSocials from "./aboutYou/socials";
import ApplicationConfirmationCode from "./confirmationCode";
import ApplicationMembership from "./membership";
import ApplicationPayment from "./payment";
import ApplicationAboutYouAddressAndBirthday from "./personalInformation/addressAndBirthdate";
import ApplicationAboutYouJob from "./personalInformation/job";
import ApplicationAboutYouLogin from "./personalInformation/login";
import ApplicationProfilePicture from "./profilePicture";
import ApplicationStartMembership from "./startMembership";
import ApplicationSuccessful from "./success";

type Props = {
  step: number;
  reachedStep: number;
  clientSecret: string;
  passwordText: string;
  handleSetPasswordText: (text: string) => void;
  goToNextStep: () => void;
};

const ApplicationSections = ({
  step,
  reachedStep,
  passwordText,
  handleSetPasswordText,
  goToNextStep,
}: Props) => {
  return (
    <>
      {[
        <ApplicationStartMembership key="application-section-ApplicationStartMembership" />,
        <ApplicationAboutYouLogin
          key="application-section-ApplicationAboutYouLogin"
          passwordText={passwordText}
          handleSetPasswordText={handleSetPasswordText}
        />,
        <ApplicationAboutYouAddressAndBirthday key="application-section-ApplicationAboutYouAddressAndBirthday" />,
        <ApplicationAboutYouJob key="application-section-ApplicationAboutYouJob" />,
        <ApplicationProfilePicture key="application-section-ApplicationProfilePicture" />,
        <ApplicationBiographyAndJoining key="application-section-ApplicationBiographyAndJoining" />,
        <ApplicationAboutYouSocials key="application-section-ApplicationAboutYouSocials" />,
        <ApplicationMembership key="application-section-ApplicationMembership" />,
        <ApplicationConfirmationCode
          key="application-section-ApplicationConfirmationCode"
          goToNextStep={goToNextStep}
        />,
        <ApplicationPayment
          handleNext={goToNextStep}
          key="application-section-ApplicationPayment"
        />,
        <ApplicationSuccessful key="application-section-ApplicationSuccessful" />,
      ].map(
        (section, i) =>
          // i >= 8 &&
          i >= 0 &&
          reachedStep >= i && (
            <ApplicationFieldset
              key={`membership-application-section-${i}`}
              hidden={step != i}
            >
              {section}
            </ApplicationFieldset>
          )
      )}
    </>
  );
};

export default ApplicationSections;
